module.exports = {"cookies":"Cookies","help":"Hilfe","privacy":"Datenschutz","signInButtonText":"Mit einer Adobe ID anmelden","termsOfUse":"Nutzungsbedingungen","updated":"AKTUALISIERT"}


//////////////////
// WEBPACK FOOTER
// ./src/components/ExpLogin/__localization__/ExpLogin/de_de.json
// module id = 943
// module chunks = 0